import { inject, Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';

import {
  SpecificationSettingState,
  SpecificationSettingStore,
} from './specification-setting.store';

@Injectable({ providedIn: 'root' })
export class SpecificationSettingQuery extends QueryEntity<SpecificationSettingState> {
  protected store: SpecificationSettingStore;

  constructor() {
    const store = inject(SpecificationSettingStore);

    super(store);

    this.store = store;
  }
}
